package com.fireavert.management_companies.data_models

import kotlinx.serialization.Serializable

@Serializable
data class ManagementCompany(
    val id: Int,
    val name: String,
)
